import {
  PropertyValueAttribute,
  Ruleset,
  Tag,
} from "../parameters/pl-parameters.types";

export enum DataTypeEnum {
  STRING = "STRING",
  BOOL = "BOOL",
  FLOAT = "FLOAT",
  INT = "INT",
}

export const dataTypesOptions: DataTypeEnum[] = [
  DataTypeEnum.STRING,
  DataTypeEnum.BOOL,
  DataTypeEnum.FLOAT,
  DataTypeEnum.INT,
];

export const booleanOptions: boolean[] = [true, false];

export enum DomainEnum {
  DISCRETE = "DISCRETE",
  OPEN = "OPEN",
  RANGE = "RANGE",
}

export const domainOptions: DomainEnum[] = [
  DomainEnum.DISCRETE,
  DomainEnum.OPEN,
  DomainEnum.RANGE,
];

export interface PropertiesState {
  byId: any;
  allIds: string[];
  total: number;
  page: number;
  newProperty: any;
  getting: boolean;
  deleting: boolean;
  posting: boolean;
}

export enum PropertyType {
  Main = "main",
  PVA = "pva",
  SubPropStd = "standardSubProperty",
  SubPropCustom = "subproperties",
}

export interface Property {
  id?: string;
  productlineId: string;
  parentId?: string | null;
  name: string;
  dataType: DataTypeEnum;
  domain: DomainEnum;
  default?: string | null;
  rulesetIds: string[];
  tagIds: string[];
  propertyValueAttributeIds: string[];
  propertyValues: PropertyValue[];
  comments: string;
  sources: string;
  autoSelection: boolean;
  ownerTool: string;
  dbSchemaVersion?: number;
}

export interface PropertyResponse {
  id?: string;
  productLineId: string;
  parentId: string | null;
  name: string;
  dataType: DataTypeEnum;
  domain: DomainEnum;
  default?: string | null;
  ruleSets: Ruleset[];
  tags: Tag[];
  propertyValueAttributes: PropertyValueAttribute[];
  propertyValues: PropertyValueResponse[];
  comments: string;
  sources: string;
  autoSelection: boolean;
  ownerTool: string;
  dbSchemaVersion: number;
  isSubProp?: boolean;
  isStandardSubProp?: boolean;
  isPVAProp?: boolean;
  validations: any;
}

export interface PropertyValue {
  id?: string;
  valueAttributeCells: ValueAttributeCell[];
}

export interface PropertyValueResponse {
  id?: string;
  valueAttributeCells: ValueAttributeCellResponse[];
}

export interface ValueAttributeCell {
  propertyValueAttributeId: string;
  value: string;
}

export interface ValueAttributeCellResponse {
  propertyValueAttribute: PropertyValueAttribute;
  value: string;
}

export interface PropertyPage {
  total: number;
  items: number;
  page: number;
  properties: Property[];
}

export interface PropertyResponsePage {
  total: number;
  items: number;
  page: number;
  properties: PropertyResponse[];
}

export interface PropertyQueryParams {
  name?: string;
  dataTypes?: any;
  tags?: any;
  ruleSets?: any;
  domains?: any;
  includePVAProperties?: boolean;
  includeSubProperties?: boolean;
  items?: number | string;
  page?: number;
  exclusiveRulesetFilter?: boolean;
  regexNameMatch?: boolean;
}
